"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initTableWithScrollableCells = void 0;
function initTableWithScrollableCells(table) {
    var currentCell = null;
    table.addEventListener("mouseover", function (event) {
        if (currentCell)
            return;
        if (event.target instanceof HTMLElement) {
            currentCell = event.target.closest('.td-scroll');
        }
        if (currentCell && table.contains(currentCell)) {
            table.setAttribute('last-scroll-top', window.pageYOffset.toString());
            currentCell.addEventListener("wheel", wheel);
        }
    });
    table.addEventListener("mouseout", function (event) {
        if (!currentCell)
            return;
        var relatedTarget = event.relatedTarget;
        while (relatedTarget instanceof HTMLElement) {
            if (relatedTarget === currentCell)
                return;
            relatedTarget = relatedTarget.parentNode;
        }
        currentCell.removeEventListener("wheel", wheel);
        currentCell = null;
    });
}
exports.initTableWithScrollableCells = initTableWithScrollableCells;
var wheel = function (event) {
    if (event.target instanceof HTMLElement) {
        var table = event.target.closest('table');
        var startPageY = parseFloat(table.getAttribute('last-scroll-top'));
        var isPageScroll = (startPageY !== window.pageYOffset);
        var scrollableList_1 = event.target.closest(".select2-selection__rendered");
        if (scrollableList_1 instanceof HTMLUListElement && isCellScrolling(event) && !isPageScroll) {
            var scrollCoefficient_1 = 0.007;
            var scrollableCellWidth_1 = event.target.closest("td").clientWidth;
            requestAnimationFrame(function () {
                scrollableList_1.scrollLeft += scrollCoefficient_1 * event.deltaY * scrollableCellWidth_1;
            });
            event.preventDefault();
        }
    }
};
function isCellScrolling(event) {
    if (event.target instanceof HTMLElement) {
        var scrollableList = event.target.closest(".select2-selection__rendered");
        var isWheelUp = event.deltaY < 0;
        var isListAtStart = scrollableList.scrollLeft === 0;
        var isListAtEnd = (scrollableList.scrollWidth - scrollableList.scrollLeft) === scrollableList.clientWidth;
        return !(isListAtStart && isWheelUp) && !(isListAtEnd && !isWheelUp);
    }
}
